  <template>
    <main>
        <section class="dashboard">
            <div class="container">
                <div class="row row-spacing-btm">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="widget quick-widgets">
                            <h3 class="widget-heading success-badge">
                                Successful<br>Transactions
                            </h3>
                            <ul class="quick-stats clearfix">
                                <li>
                                    <span class="float-left">Last 24h </span>
                                    <span class="float-right stats text-right">498</span>
                                </li>
                                <li class="past-week">
                                    <span class="float-left">Last week</span>
                                    <span class="float-right stats text-right">3,948</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="widget quick-widgets">
                            <h3 class="widget-heading failed-badge">
                                Not Eligible for<br>ePayLater
                            </h3>
                            <ul class="quick-stats clearfix">
                                <li>
                                    <span class="float-left">Last 24h </span>
                                    <span class="float-right stats text-right">13</span>
                                </li>
                                <li class="past-week">
                                    <span class="float-left">Last week</span>
                                    <span class="float-right stats text-right">32</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="widget quick-widgets">
                            <h3 class="widget-heading pending-badge">
                                Pending<br>Transactions
                            </h3>
                            <ul class="quick-stats clearfix">
                                <li>
                                    <span class="float-left">Last 24h </span>
                                    <span class="float-right stats text-right">15</span>
                                </li>
                                <li class="past-week">
                                    <span class="float-left">Last week</span>
                                    <span class="float-right stats text-right">48</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row row-spacing-btm">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <div class="widget total-amount-hourly-widget">
                            <div class="widget-head clearfix">
                                <h3 class="widget-heading float-left">
                                    Total<br>amount in <br>last 24 hrs
                                </h3>
                                <span class="hr-amount float-right">
                                    <i class="ic-rupee">`</i>43,900
                                </span>
                            </div>

                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td class="txt-label">Last 7 days</td>
                                        <td class="text-right">
                                            <i class="ic-rupee">`</i>89,450
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="txt-label">Current Month</td>
                                        <td class="text-right">
                                            <i class="ic-rupee">`</i>1,50,000
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="txt-label">Previous Month</td>
                                        <td class="text-right">
                                            <i class="ic-rupee">`</i>1,28,500
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                        <div class="widget">
                            <h3 class="widget-heading">
                                Settlements
                                <router-link :to="{ name: 'Settlements' }" class="viewall"> View All </router-link>
                            </h3>
                            <table class="table dashboard-settlements">
                                <thead>
                                    <tr>
                                        <th>Reference ID</th>
                                        <th>Amount</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456789</td>
                                        <td>10,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456666</td>
                                        <td>5,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456453</td>
                                        <td>1,00,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456986</td>
                                        <td>15,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456789</td>
                                        <td>2,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-uppercase">ABCDE123456789</td>
                                        <td>2,000</td>
                                        <td class="col-date">30 Jan 2018 <span>16:20:12</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row row-spacing-btm">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="widget">
                          <highcharts :options="lineChart"></highcharts>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="widget">
                          <highcharts :options="barChart"></highcharts>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
  </template>

  <script>
    export default {
      name: 'Dashboard',
      data () {
        return {

          lineChart:{
            title: {
                text: 'Chart title goes here'
            },
            subtitle: {
                text: 'Subtitle goes here'
            },
            yAxis: {
                title: {
                    text: 'Number of Employees'
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle'
            },
            plotOptions: {
                series: {
                    label: {
                    connectorAllowed: false
                    },
                    pointStart: 2010
                }
            },
            series: [{
                name: 'Installation',
                data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
              }, {
                name: 'Manufacturing',
                data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
              }, {
                name: 'Sales & Distribution',
                data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387]
              }, {
                name: 'Project Development',
                data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227]
              }, {
                name: 'Other',
                data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111]
              }],

            responsive: {
                    rules: [{
                        condition: {
                        maxWidth: 500
                        },
                        chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                        }
                    }]
                }
          },
          barChart:{
            chart: {
              type: 'column'
            },
            title: {
                text: 'title goes here'
            },
            subtitle: {
                text: 'subtitle goes here'
            },
            xAxis: {
              categories: [
                  'Jan',
                  'Feb',
                  'Mar',
                  'Apr',
                  'May',
                  'Jun',
                  'Jul',
                  'Aug',
                  'Sep',
                  'Oct',
                  'Nov',
                  'Dec'
              ],
              crosshair: true
            },
            yAxis: {
              min: 0,
              title: {
                  text: 'Rainfall (mm)'
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            },
            series: [{
                      name: 'Tokyo',
                      data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4]
                    }, {
                      name: 'New York',
                      data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5, 106.6, 92.3]
                    }, {
                      name: 'London',
                      data: [48.9, 38.8, 39.3, 41.4, 47.0, 48.3, 59.0, 59.6, 52.4, 65.2, 59.3, 51.2]
                    }, {
                      name: 'Berlin',
                      data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1]
                    }]
          }
        }
      },
      mounted(){
      }
    }
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import '../assets/scss/custom.scss';

  /*---------- dashboard content style ----------*/
  .dashboard {
      @extend .section-margin;
      .row {
          & > [class^="col-"],
          & > [class*=" col-"] {
              padding-left: rem(7px);
              padding-right: rem(7px);
          }
      }
  }
  .widget {
      background: $colorwhite;
      padding: rem(32px);
      @include border-radius(rem(8px), rem(8px), rem(8px), rem(8px));
  }

  .quick-widgets {
      overflow: hidden;
      h3 {
          @extend .widget-heading;
          height: rem(80px);
          &.success-badge, &.failed-badge, &.pending-badge {
              &:before, &:after {
                  content: '';
                  position: absolute;
                  @include border-radius(rem(10px), rem(10px), rem(10px), rem(10px));
                  width: rem(60px);
              }
          }
          &.success-badge, &.failed-badge, &.pending-badge {
              &:before {
                  height: rem(82px);
                  right: rem(4px);
                  top: 0;
              }
              &:after {
                  height: 6.8rem;
                  top: rem(-40px);
                  right: rem(-12px);
              }
          }
          &.success-badge {
              &:before {
                  background: rgba(89, 205, 144, 0.05);
              }
              &:after {
                  background: rgba(89, 205, 144, 0.08) path("ic-success.svg",images/icons) center 50% no-repeat;
              }
          }
          &.failed-badge {
              &:before {
                  background: rgba(244, 92, 95, 0.05);
              }
              &:after {
                  background: rgba(244, 92, 95, 0.08) path("ic-failed.svg",images/icons) center 50% no-repeat;
              }
          }
          &.pending-badge {
              &:before {
                  background: rgba(247, 206, 91, 0.08);
              }
              &:after {
                  background: rgba(247, 206, 91, 0.1) path("ic-pending.svg",images/icons) center 50% no-repeat;
              }
          }
      }
      ul {
          margin-top: rem(15px);
          li {
              display: flex;
              align-items: baseline;
              color: #b0bfd9;
              &:first-child {
                  color: $basetextcolor;
                  padding-bottom: rem(8px);
                  border-bottom: rem(solid 1px #f1f2f3);
                  margin-bottom: rem(16px);
              }
              span {
                  display: inline-block;
                  width: 50%;
              }
              span.stats {
                  font-size: rem(32px);
                  color: $widgetheadingcolor;
                  font-weight: 700;
                  margin: 0;
              }
              &.past-week {
                  span.stats {
                      font-size: rem(20px);
                      color: $basetextcolor;
                      font-weight: 400;
                      margin: 0;
                  }
              }
          }
      }
  }


  .total-amount-hourly-widget {
    background: $colorwhite path("total-amount-widget-bg.png") no-repeat bottom;
    background-size: contain;
    padding-bottom: rem(135px);
    .hr-amount {
      position: relative;
      font-size: rem(32px);
      color: $widgetheadingcolor;
      font-weight: 700;
      &:after {
        content: '';
        width: rem(18px);
        height: rem(4px);
        background: $secondaryColor;
        position: absolute;
        right: rem(5px);
        bottom: rem(-5px);
      }
    }
    table {
      margin-top: rem(20px);
      tr {
        td:last-child {
          font-size: rem(16px);
        }
      }
    }
  }


  </style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue